import React, { useState, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import { useParams, Link, useSearchParams } from 'react-router-dom';

// 样式组件定义
const PageContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
`;

const Header = styled.div`
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(20px);
  padding: 32px;
  border-radius: 16px;
  margin-bottom: 24px;
  display: flex;
  gap: 40px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.01);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 36px rgba(0, 0, 0, 0.01);
  }
`;

const CoverImage = styled.img`
  width: 420px;
  height: 280px;
  object-fit: cover;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  flex-shrink: 0;
`;

const HeaderContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 280px; // 与CoverImage高度保持一致
  justify-content: flex-start; // 改为从顶部开始布局
`;

const TopSection = styled.div`
  flex-shrink: 0;
`;

const MiddleSection = styled.div`
  flex-shrink: 0;
  margin-top: 16px; // 添加固定的上边距
`;

const BottomSection = styled.div`
    padding-top: 10px;
`;

const Title = styled.h1`
  font-size: 32px;
  font-weight: 600;
  margin-bottom: 0px;
  background: linear-gradient(135deg, #1a1a1a 0%, #4a4a4a 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  letter-spacing: -0.5px;
`;

const Subtitle = styled.p`
  color: #666;
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 0;
  font-weight: 400;
`;

const Stats = styled.div`
  display: flex;
  align-items: center;
  gap: 40px;
  padding: 16px;
  background: rgba(245, 245, 247, 0.6);
  border-radius: 12px;
  margin: 0 0 14px 0; // 只保留底部间距
  border: 1px solid rgba(207, 213, 255, 0.13);
`;

const PriceInfo = styled.div`
  .current-price-old{
    color: #000;
    font-size: 28px;
    font-weight: 600;
    margin-right: 12px;
    letter-spacing: -0.5px;
    }

    .current-price{
    
     font-size: 36px;
    font-weight: 600;
    font-feature-settings: "tnum";
    background: linear-gradient(135deg,rgb(238, 10, 10) 0%,rgb(177, 0, 0) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    letter-spacing: -1px;
    margin-right: 12px;
    }


  .original-price {
    color: rgb(98, 98, 98); /* 直接设置文字颜色 */
    text-decoration: line-through;
    text-decoration-thickness: 2px;
    font-size: 16px;
    font-weight: 400;
  }
`;

const BasicInfo = styled.div`
  display: flex;
  gap: 24px;
  position: relative;
  padding-left: 24px;
  align-items: center; // 确保垂直居中对齐

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 1px;
    height: 24px;
    background: rgba(0, 0, 0, 0.1);
  }

  span {
    color: #1d1d1f;
    font-size: 14px;
    font-weight: 500;
    display: inline-flex; // 改为 inline-flex 使 span 内部元素也水平排列
    align-items: center;
    gap: 6px;
    white-space: nowrap; // 确保 span 内部文字不换行

    &::before {
      content: '';
      display: inline-block;
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background: #007AFF;
      opacity: 0.5;
      flex-shrink: 0; // 防止小圆点被压缩
    }
  }
`;

const Features = styled.div`
  display: flex;
  gap: 12px;
  margin: 0; // 移除所有外边距
`;

const FeaturesContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding-bottom: 8px;
`;

const ValidityInfo = styled.div`
  color: #666;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
`;

const FeatureTag = styled.span`
  position: relative;
  padding: 6px 16px;
  background: rgba(0, 122, 255, 0.1);
  color: #007AFF;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
  cursor: default;

  &:hover {
    background: rgba(0, 122, 255, 0.15);
    transform: translateY(-1px);
  }

  &::after {
    content: attr(data-tooltip);
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    margin-bottom: 8px;
    
    background: rgba(0, 0, 0, 0.85);
    color: white;
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 400;
    white-space: nowrap;
    z-index: 10;
    
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    transition: opacity 0.2s ease, visibility 0.2s ease;
  }

  &:hover::after {
    opacity: 1;
    visibility: visible;
  }
`;

const EnrollButton = styled.button`
  background: #007AFF;
  color: white;
  border: none;
  padding: 14px 32px;
  border-radius: 12px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  transition: all 0.3s ease;
  width: fit-content;
  margin: 0; // 移除所有外边距

  &:hover {
    background: #0066CC;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 122, 255, 0.3);
  }

  &:active {
    transform: translateY(0);
  }
`;

const Content = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 20px;
`;

const ContentTabs = styled.div`
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  position: relative;
`;

const TabList = styled.div`
  display: flex;
  gap: 20px;
  border-bottom: 1px solid #eee;
  margin-bottom: 20px;
  
  position: sticky;
  top: 60px;
  background-color: #fff;
  padding-top: 15px;
  padding-bottom: 10px;
  z-index: 10;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
  margin-top: -20px;
  padding-left: 20px;
  padding-right: 20px;
  margin-left: -20px;
  margin-right: -20px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
`;

const Tab = styled.span`
  padding: 10px 0;
  cursor: pointer;
  color: ${props => props.active ? '#405EB2' : '#333'};
  border-bottom: ${props => props.active ? '2px solid #405EB2' : 'none'};
  font-size:15px;
  font-weight:500;
`;

const Sidebar = styled.div`
  background: #fff;
  border-radius: 8px;
  padding: 20px;
`;

const TeacherCard = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 15px;
  border-bottom: 1px solid #eee;

  &:last-child {
    border-bottom: none;
  }
`;

const TeacherAvatar = styled.img`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  object-fit: cover;
`;

const TeacherInfo = styled.div`
  h4 {
    margin: 0;
    font-size: 16px;
  }

  p {
    margin: 5px 0 0;
    color: #666;
    font-size: 14px;
  }
`;

const featureTooltips = {
  '问': '提问必答',
  '疑': '一对一在线答疑',
  '动': '班级活动',
  '业': '就业指导'
};

// 新增：包裹介绍内容的容器，并定义内部样式
const IntroductionContent = styled.div`
  line-height: 1.8; // 增加行高
  color: #333; // 设置默认文字颜色

  h2 {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 24px; // 标题下间距
    color: #1d1d1f; // 标题颜色
    padding-bottom: 10px;
    border-bottom: 1px solid #eee; // 标题下划线
  }

  p {
    margin-bottom: 1.2em; // 段落间距
    font-size: 15px; // 正文字体大小
    color: #444; // 正文颜色
  }

  strong {
    font-weight: 600; // 强调文字加粗
    color: #0056b3; // 强调文字颜色 (示例)
    background: rgba(0, 122, 255, 0.05); // 强调文字轻微背景
    padding: 0.1em 0.3em;
    border-radius: 4px;
  }
  
  // 可以为特定段落添加类名以应用不同样式
  .philosophy { 
    font-style: italic;
    color: #555;
    padding: 1em;
    background-color: #f8f9fa;
    border-left: 3px solid #007AFF;
    border-radius: 4px;
    margin-top: 1.5em;
  }
`;

// 新增：课程列表容器
const CourseListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px; // 课程项之间的间距
`;

// 新增：单个课程项容器
const CourseItemContainer = styled(Link)`
  display: flex;
  gap: 20px;
  padding: 20px;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02);
  transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
  border: 0.5px solid #eee;
  text-decoration: none;
  color: inherit;
  cursor: pointer;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
    border-color: rgba(0, 122, 255, 0.1);
  }
`;

// 新增：课程封面图片
const CourseItemImage = styled.img`
  width: 240px; // 固定宽度
  height: 160px; // 固定高度
  object-fit: cover;
  border-radius: 8px;
  flex-shrink: 0; // 防止图片被压缩
`;

// 新增：课程信息区域
const CourseItemInfo = styled.div`
  flex: 1; // 占据剩余空间
  display: flex;
  flex-direction: column;
`;

// 新增：课程标题
const CourseItemTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 8px 0;
  color: #1d1d1f;
  line-height: 1.4;
`;

// 新增：教学计划
const CourseItemPlan = styled.p`
  font-size: 14px;
  color: #666;
  margin: 0 0 16px 0; // 增加与下方元素的间距
  line-height: 1.5;
`;

// 新增：底部信息（教师、课时、价格）容器
const CourseItemBottom = styled.div`
  margin-top: auto; // 将底部信息推到底部
  display: flex;
  justify-content: space-between; // 两端对齐
  align-items: flex-end; // 底部对齐
  padding-top: 10px; // 增加顶部内边距
  border-top: 1px solid #f0f0f0; // 添加分隔线
`;

// 新增：教师信息
const CourseItemTeacher = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  img {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    object-fit: cover;
  }

  span {
    font-size: 14px;
    color: #333;
    font-weight: 500;
  }
`;

// 新增：课时和价格信息
const CourseItemMeta = styled.div`
  display: flex;
  align-items: flex-end; // 底部对齐
  gap: 20px; // 增加元素间距

  .lessons {
    font-size: 14px;
    color: #666;
  }

  .price {
    font-size: 20px;
    font-weight: 600;
    color: #e4393c; // 价格使用醒目的红色
    font-feature-settings: "tnum"; // 等宽数字
  }
`;

// 新增：单个课程项组件
const ClassCourseItem = ({ course }) => (
  <CourseItemContainer to={`/course/${course.id}`}>
    <CourseItemImage src={course.coverImage} alt={course.title} />
    <CourseItemInfo>
      <CourseItemTitle>{course.title}</CourseItemTitle>
      <CourseItemPlan>{course.plan}</CourseItemPlan>
      <CourseItemBottom>
        <CourseItemTeacher>
          <img src={course.teacher.avatar} alt={course.teacher.name} />
          <span>{course.teacher.name}</span>
        </CourseItemTeacher>
        <CourseItemMeta>
          <span className="lessons">共{course.totalLessons}课时</span>
          <span className="price">¥{course.price.toFixed(2)}</span>
        </CourseItemMeta>
      </CourseItemBottom>
    </CourseItemInfo>
  </CourseItemContainer>
);

// 新增：评价列表容器
const ReviewListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 25px; // 评价项之间的间距
`;

// 新增：单个评价项容器
const ReviewItemContainer = styled.div`
  display: flex;
  gap: 15px;
  padding-bottom: 25px; // 底部留白，并用边框分隔
  border-bottom: 1px solid #f0f0f0;

  &:last-child {
    border-bottom: none; // 最后一项不需要下边框
    padding-bottom: 0;
  }
`;

// 新增：评价者头像
const ReviewItemAvatar = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
`;

// 新增：评价主要内容区域（用户名、日期、星级、内容）
const ReviewItemMain = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px; // 内容区域内部元素间距
`;

// 新增：评价头部（用户名和日期）
const ReviewItemHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

// 新增：评价者用户名
const ReviewItemUsername = styled.span`
  font-size: 15px;
  font-weight: 600;
  color: #333;
`;

// 新增：评价日期
const ReviewItemDate = styled.span`
  font-size: 13px;
  color: #999;
`;

// 新增：星级评分
const ReviewItemRating = styled.div`
  color: #ffb400; // 星星颜色
  font-size: 16px; // 星星大小
  line-height: 1; // 确保星星紧凑排列

  span {
    margin-right: 2px; // 星星之间的间距
  }
`;

// 新增：评价内容
const ReviewItemContent = styled.p`
  font-size: 14px;
  color: #555;
  line-height: 1.7;
  margin: 0; // 移除默认的 p 标签边距
  white-space: pre-wrap; // 保留换行符
`;

// --- Helper Function for Stars ---
// (可以放在组件外部或 utils 文件中)
const renderStars = (rating) => {
  const fullStars = Math.floor(rating);
  // 可选：处理半星等情况，这里简化为全星
  const stars = '★'.repeat(fullStars) + '☆'.repeat(5 - fullStars);
  return <span>{stars}</span>;
};

// 新增：单个评价项组件
const ClassReviewItem = ({ review }) => (
  <ReviewItemContainer>
    <ReviewItemAvatar src={review.user.avatar} alt={review.user.name} />
    <ReviewItemMain>
      <ReviewItemHeader>
        <ReviewItemUsername>{review.user.name}</ReviewItemUsername>
        <ReviewItemDate>{review.date}</ReviewItemDate>
      </ReviewItemHeader>
      <ReviewItemRating>{renderStars(review.rating)}</ReviewItemRating>
      <ReviewItemContent>{review.content}</ReviewItemContent>
    </ReviewItemMain>
  </ReviewItemContainer>
);

// 新增：加载更多按钮样式
const LoadMoreButton = styled.button`
  display: block;
  width: fit-content;
  margin: 20px auto 0; // 顶部间距，居中
  padding: 10px 25px;
  background-color: #f0f2f5;
  color: #555;
  border: 1px solid #e0e0e0;
  border-radius: 20px; // 圆角
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;

  &:hover:not(:disabled) {
    background-color: #e8eaed;
    color: #333;
    border-color: #d0d0d0;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

// 新增：加载中动画
const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const LoadingSpinner = styled.div`
  display: inline-block; // 与文字同行显示
  width: 14px;
  height: 14px;
  border: 2px solid rgba(0, 0, 0, 0.1);
  border-left-color: #555;
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
  margin-left: 8px; // 与按钮文字间距
  vertical-align: middle; // 垂直居中
`;

// --- ClassDetailPage Component ---
const REVIEWS_PER_PAGE = 3; // 每次加载3条评价

const ClassDetailPage = () => {
  const { classId } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const [classData, setClassData] = React.useState(null);
  const [displayedReviews, setDisplayedReviews] = useState([]); // 当前显示的评价
  const [hasMoreReviews, setHasMoreReviews] = useState(false); // 是否还有更多评价
  const [isLoadingMore, setIsLoadingMore] = useState(false); // 是否正在加载更多
  const [loading, setLoading] = React.useState(true);

  const initialTab = searchParams.get('tab') || 'intro';
  const [activeTab, setActiveTab] = React.useState(
    ['intro', 'courses', 'reviews'].includes(initialTab) ? initialTab : 'intro'
  );

  useEffect(() => {
    const fetchClassData = () => {
      setLoading(true); // 开始加载时设置 loading
      setTimeout(() => {
        const coreClassData = {
          id: classId,
          title: 'Unity超级无敌班',
          subtitle: '学习是对自己最好的投资，无限进步，永不止步......',
          price: 1999,
          originalPrice: 2499,
          totalLessons: 20,
          totalHours: 688,
          studentCount: 356,
          validity: '长期有效',
          features: ['问', '疑', '动', '业'],
          coverImage: 'https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/course/2025/01-23/1546317ee1a5714509.png',
          teachers: [
            {
              name: 'Plane老师',
              title: '元宇宙造梦大师，计算机开发爱好者',
              avatar: 'https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/user/2020/11-28/0137062c3032405892.jpg'
            },
            {
              name: 'Frank大师',
              title: 'Pornhub高级研究员，首席高级资深抖扣科学家',
              avatar: 'https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/default/2021/06-15/233803b2c9c7932145.jpg'
            },
            {
              name: '苍老师',
              title: '爱情影像大师',
              avatar: 'https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/system/2021/02-25/022306a500e5903269.png'
            }
          ],
          introduction: `
            <p>我们将专注于<strong>高品质游戏实战教学</strong>，不做营销，不搞活动，看课买课，全凭缘分。</p>
            <p>我们认为<strong>高质量的课程</strong>才是<strong>核心竞争力</strong>，全部课程经过完整录制；全部视频经过精心剪辑降噪，确保内容充实、文件完备、讲解流畅无废话。</p>
            <p>我们的目标是打造基于Unity的主流游戏类型的<strong>「实战案例」</strong>课程，并针对商业项目的重点难点，开发通用模块<strong>「技术专题」</strong>课程。内容不重复，不出口水课。</p>
            <p>我们将专注于游戏开发领域，所有课程围绕游戏开发展开开，不断提高课程质量，完善课程体系。</p>
            <p>咨询<span style="color: #ff0000;">QQ</span>:<strong>1785275942</strong>   <span style="color: #ff0000;">VX</span>:<strong>PlaneZhong</strong></p>
            <p style="color: #ff0000; font-weight: 600;">随着课程增多，网站流量成本剧增。为了能持续运营，从2024年3月1日起对「Unity永久班」限量发售，每月仅售4份，先到先得。</p>
            <p class="philosophy">我们坚信，在充满竞争的世界里，真诚的热可以有所作为！</p>
          `
        };
        const mockCourses = [
          {
            id: 1,
            title: '《MMO状态同步组队战斗分布式滚服案例课程》',
            plan: '教学计划：《MMO状态同步组队战斗分布式滚服案例课程》-默认计划',
            teacher: { name: 'Plane老师', avatar: 'https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/user/2020/11-28/0137062c3032405892.jpg' },
            totalLessons: 293,
            price: 1998.00,
            coverImage: 'https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/course/2024/03-03/2304160d3254149069.png'
          },
          {
            id: 2,
            title: '类《王者荣耀》帧同步实时对战Moba案例',
            plan: '教学计划：类《王者荣耀》帧同步实时对战Moba案例-默认计划',
            teacher: { name: 'Plane老师', avatar: 'https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/user/2020/11-28/0137062c3032405892.jpg' },
            totalLessons: 224,
            price: 999.00,
            coverImage: 'https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/course/2021/04-25/04241715a328142274.png'
          },
          {
            id: 3,
            title: '滚服分布式网络通信框架',
            plan: '教学计划：滚服分布式网络通信框架-默认计划',
            teacher: { name: 'Plane老师', avatar: 'https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/user/2020/11-28/0137062c3032405892.jpg' },
            totalLessons: 44,
            price: 499.00,
            coverImage: 'https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/course/2025/01-23/1546317ef005561898.png'
          },
          {
            id: 4,
            title: '网络通信原理与实战应用',
            plan: '教学计划：网络通信原理与实战应用-默认计划',
            teacher: { name: 'Plane老师', avatar: 'https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/user/2020/11-28/0137062c3032405892.jpg' },
            totalLessons: 37,
            price: 199.00,
            coverImage: 'https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/course/2024/01-07/01124913404f248211.png'
          },
           {
            id: 5,
            title: '导出Navmesh到服务器中寻路',
            plan: '教学计划：导出Navmesh到服务器中寻路-默认计划',
            teacher: { name: 'Plane老师', avatar: 'https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/user/2020/11-28/0137062c3032405892.jpg' },
            totalLessons: 21,
            price: 256.00,
            coverImage:'https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/course/2023/07-17/084102e58bca736163.png'
          },
        ];

        // 新增：模拟评价数据
        const mockReviews = [
          {
            id: 1,
            user: { name: 'srf4200', avatar: 'https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/user/2023/05-13/153848844d85963149.jpeg' }, // 替换为实际头像URL
            date: '2024-03-08',
            rating: 5,
            content: '看了不少网课，最喜欢Plane老师讲的课，干货多，详细但不拖沓，良心老师'
          },
          {
            id: 2,
            user: { name: 'Slony', avatar: 'https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/user/2021/04-12/1743208882ee287475.jpeg' }, // 替换为实际头像URL
            date: '2023-06-30',
            rating: 5,
            content: '以案例来引入课程，课件，导图都很详细，对比市面上的很多课程来说，真的很良心了，全是干货'
          },
          {
            id: 3,
            user: { name: '愚昧', avatar: 'https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/default/2021/06-30/174410ad4421367405.jpg' }, // 替换为实际头像URL
            date: '2023-06-11',
            rating: 5,
            content: 'plane老师的课程都是良心之作，课程内容有深度，绝对不是拿入门级的案例来骗人'
          },
          {
            id: 4,
            user: { name: 'xxydw', avatar: 'https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/default/2021/06-26/1026295672dd305288.jpg' }, // 替换为实际头像URL
            date: '2023-01-03',
            rating: 5,
            content: '老师实战经验教学，课件质量很好，推荐！'
          },
        ];
        
        // 将课程和评价数据合并到班级数据中
        const allData = { ...coreClassData, courses: mockCourses, reviews: mockReviews };
        setClassData(allData);

        // 初始化显示的评价
        const initialReviews = allData.reviews?.slice(0, REVIEWS_PER_PAGE) || [];
        setDisplayedReviews(initialReviews);
        setHasMoreReviews((allData.reviews?.length || 0) > REVIEWS_PER_PAGE);

        setLoading(false);
      }, 500); // 增加一点延迟模拟真实加载
    };

    fetchClassData();
  }, [classId]);

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
    setSearchParams({ tab: tabName }, { replace: true });
  };

  // 新增：加载更多评价的处理函数
  const handleLoadMoreReviews = () => {
    if (!classData || !classData.reviews || isLoadingMore) return;

    setIsLoadingMore(true);

    // 模拟网络延迟
    setTimeout(() => {
      const currentLength = displayedReviews.length;
      const nextReviews = classData.reviews.slice(
        currentLength,
        currentLength + REVIEWS_PER_PAGE
      );

      setDisplayedReviews(prevReviews => [...prevReviews, ...nextReviews]);
      setHasMoreReviews(currentLength + nextReviews.length < classData.reviews.length);
      setIsLoadingMore(false);
    }, 300); // 模拟加载延迟
  };

  if (loading && !classData) {
    return <div>加载中...</div>;
  }

  if (!classData) {
    return <div>未找到班级信息</div>;
  }

  return (
    <PageContainer>
      <Header>
        <CoverImage src={classData.coverImage} alt={classData.title} />
        <HeaderContent>
          <TopSection>
            <Title>{classData.title}</Title>
            <Subtitle>{classData.subtitle}</Subtitle>
          </TopSection>
          
          <MiddleSection>
            <Stats>
              <PriceInfo>
                <span className="current-price">¥{classData.price}</span>
                <span className="original-price">¥{classData.originalPrice}</span>
              </PriceInfo>
              
              <BasicInfo>
                <span>共{classData.totalLessons}课程</span>
                <span>{classData.totalHours}小时</span>
                <span>{classData.studentCount}人订阅</span>
              </BasicInfo>
            </Stats>

            <FeaturesContainer>
              <Features>
                {classData.features.map((feature, index) => (
                  <FeatureTag 
                    key={index} 
                    data-tooltip={featureTooltips[feature] || ''}
                  >
                    {feature}
                  </FeatureTag>
                ))}
              </Features>

              <ValidityInfo>
                <span>有效期：{classData.validity}</span>
              </ValidityInfo>
            </FeaturesContainer>
          </MiddleSection>

          <BottomSection>
            <EnrollButton>购买班级</EnrollButton>
          </BottomSection>
        </HeaderContent>
      </Header>

      <Content>
        <ContentTabs>
          <TabList>
            <Tab 
              active={activeTab === 'intro'} 
              onClick={() => handleTabClick('intro')}
            >
              班级简介
            </Tab>
            <Tab 
              active={activeTab === 'courses'} 
              onClick={() => handleTabClick('courses')}
            >
              包含课程 ({classData.courses?.length || 0})
            </Tab>
            <Tab 
              active={activeTab === 'reviews'} 
              onClick={() => handleTabClick('reviews')}
            >
              班级评价 ({classData.reviews?.length || 0})
            </Tab>
          </TabList>
          
          {activeTab === 'intro' && (
            <IntroductionContent> 
              <h2>班级介绍：</h2>
              <div dangerouslySetInnerHTML={{ __html: classData.introduction }} />
            </IntroductionContent>
          )}

          {activeTab === 'courses' && (
            <CourseListContainer>
              {classData.courses && classData.courses.length > 0 ? (
                classData.courses.map(course => (
                  <ClassCourseItem key={course.id} course={course} />
                ))
              ) : (
                <p>该班级暂无课程。</p>
              )}
            </CourseListContainer>
          )}

          {activeTab === 'reviews' && (
            <>
              <ReviewListContainer>
                {displayedReviews && displayedReviews.length > 0 ? (
                  displayedReviews.map(review => (
                    <ClassReviewItem key={review.id} review={review} />
                  ))
                ) : (
                  !loading && <p>暂无评价。</p>
                )}
              </ReviewListContainer>

              {hasMoreReviews && !isLoadingMore && (
                <LoadMoreButton onClick={handleLoadMoreReviews}>
                  加载更多
                </LoadMoreButton>
              )}
              {isLoadingMore && (
                 <LoadMoreButton disabled>
                   正在加载
                   <LoadingSpinner />
                 </LoadMoreButton>
              )}
            </>
          )}
        </ContentTabs>

        <Sidebar>
          <h3>班级教师</h3>
          {classData.teachers.map((teacher, index) => (
            <TeacherCard key={index}>
              <TeacherAvatar src={teacher.avatar} alt={teacher.name} />
              <TeacherInfo>
                <h4>{teacher.name}</h4>
                <p>{teacher.title}</p>
              </TeacherInfo>
            </TeacherCard>
          ))}
        </Sidebar>
      </Content>
    </PageContainer>
  );
};

export default ClassDetailPage;
